<div class="row paddingLeft4x">
    <prism-ui-copy>
        <label>
            {{lifeAmountDollarElement?.label}}
        </label>
    </prism-ui-copy>
</div>
<div class="row paddingBottom paddingLeft4x">
                                            
    <prism-ui-form-field
        [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_dollar')"
        keyId="{{product.key + '_dollar'}}"
    >

        <span slot="helper-text">{{ lifeAmountDollarElement?.hint }}</span>
        <span slot="error">{{ lifeAmountDollarElement?.error }}</span>
        
        <prism-ui-input-currency
            aria-describedby=""
            slot="input"
            ngDefaultControl
            aria-label="{{lifeAmountDollarElement?.placeholder}}"
            autocomplete="off"
            [attr.default-value]="parentForm.get(product.key + '_dollar')?.value"
            [formGroup]="parentForm"
            [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_dollar')"
            is-disabled="false"
            is-readonly="false"
            is-required="true"
            is-small="false"
            key-id="{{product.key + '_dollar'}}"
            [maxLength] ="maxLengthAmount"
            min-length="1"
            name="{{product.key + '_dollar'}}"
            formControlName="{{product.key + '_dollar'}}"
            placeholder="{{lifeAmountDollarElement?.placeholder}}"
            size="md"
            text-align="left"
            (focusout)="handleInputFocusOut(product.key + '_dollar', $event.target.value)"
        ></prism-ui-input-currency>
    </prism-ui-form-field>
</div>